import React, { useEffect, useState } from "react";
import { Disclosure, Transition } from "@headlessui/react";
import { FiChevronDown } from "react-icons/fi";

const MenuDropDown = ({
  onClick,
  children,
  title: sTitle,
  icon: oIcon = null,
  onlyIcon: bOnlyIcon = false,
  identifier: sIdentifier,
  open: sOpen,
  defaultOpen: bDefaultOpen = false,
}) => {

  const [isOpen, setIsOpen] = useState(bDefaultOpen);

  useEffect(() => {
    if (sOpen && sOpen !== sIdentifier)
      setIsOpen(false);
  }, [sOpen]);

  // Rediseño: encabezado de grupo con el mismo estilo que los ítems y una flecha que indica si está abierto
  const sClass = [
    "flex items-center gap-2.5 w-full rounded-md text-sm transition-colors",
    bOnlyIcon ? "justify-center py-2" : "px-2.5 py-1.5",
    isOpen
      ? "text-gray-900 dark:text-white"
      : "text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white",
  ];

  const onToggle = () => {
    setIsOpen(open => !open);
    onClick(sIdentifier);
  };

  return (
    <Disclosure as="li">
      <Disclosure.Button onClick={onToggle} title={bOnlyIcon ? sTitle : undefined} className={sClass.join(" ")}>
        {oIcon}
        {!bOnlyIcon && (
          <>
            <span className="truncate">{sTitle}</span>
            <FiChevronDown className={`ml-auto h-4 w-4 shrink-0 text-gray-400 transition-transform ${isOpen ? "rotate-180" : ""}`} />
          </>
        )}
      </Disclosure.Button>
      <Transition
        show={isOpen}
        enter="transition duration-100 ease-out"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        {/* static: lo que se muestra lo decide isOpen (también cuando otro grupo lo cierra) */}
        <Disclosure.Panel
          static
          as="ul"
          className={bOnlyIcon ? "space-y-0.5 mt-0.5" : "ml-4 pl-2 border-l border-line dark:border-line-dark space-y-0.5 mt-0.5 mb-1"}
        >
          {children}
        </Disclosure.Panel>
      </Transition>
    </Disclosure>
  );
};

export default MenuDropDown;
